/** @format */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFetch } from "../../../hooks/useFetch";
import { useMessage } from "../../../hooks/UseMessage";
import OverviewInput from "../../../CommonComponents/InitialInput/OverviewInput";
import { LoadingScreen } from "../../../CommonComponents/LoadingScreen/index";
import ListModal from "../../../CommonComponents/Modal/DropDownModal/DropDownListMUI";
import CircleButton from "../../../CommonComponents/CircleButton";
import MessageLog from "../../../CommonComponents/Messages/MessageLog";
import { GetFullURL } from "../../../CommonComponents/GlobalConfFiles/URLs";
import OverviewButtons from "./Components/OverviewButtons";
import cardlogo from "../../../Assets/cardLogo.svg";

export default function AdminFunctionOverview(props) {

  let navigate = useNavigate();
  const [materialParam, setMaterialParam] = useState();
  const [showMaterialsList, setShowMaterialsList] = useState(false);
  const [_createErrorMessage, _errorMessages, _setErorMessages] = useMessage();
  
  const [
    _deleteMaterial,
    ,
    _setDeleteMaterialData,
    _errorDeleteMaterialData,
    _setErrorDeleteMaterialData,
    _successDeleteMaterialData,
    _setSuccessDeleteMaterialData,
    _loadingDeleteMaterialData,
  ] = useFetch(GetFullURL("DeleteMaterial"), { method: "POST" });

  const [_getMaterialsList, _materialsList, , , , , , _loadingMaterialsList] =
    useFetch(GetFullURL("GetAllMaterialsForDelete"), { method: "POST" });

  const [_materialExist, , , , , , , _loadingMaterialExist] = useFetch(GetFullURL("MaterialExists"),{ method: "POST" });

  function clearMessages(e) {
    e.stopPropagation();
    let type = e.target.dataset.type;
    switch (type) {
      case "success":
        _setSuccessDeleteMaterialData([]);
      
        break;
      case "error":
        _setErorMessages([]);
        _setErrorDeleteMaterialData([]);
        
        break;
      case "warning":
      default:
        break;
    }
  }
  const operationLoading =  _loadingMaterialsList  || _loadingMaterialExist ;

  return (
    <section className="heroCard heroPartner">
      {operationLoading && <LoadingScreen />}
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="cardHeader">
                <h2>
                  <span>
                  <img src={require("../../../Assets/icon/Admin.png")} className="img-fluid cardLogo" alt="" />
                  </span>
                  Material Admin Overview
                </h2>
              </div>
              <div className="cardBody">
                <div className="cardInput">
                  <OverviewInput
                    setDocument={setMaterialParam}
                    document={materialParam}
                    materialRadius={true}
                    placeholder={`Enter or Choose Id`}
                  />
                </div>
                <div className="cardButton">
                  <CircleButton
                    buttonText={`List of Materials`}
                    clickHandler={() => {
                      _getMaterialsList({},() => {setShowMaterialsList(true);});                  
                    }}
                  />
                  <OverviewButtons
                    material={materialParam}
                    navigate={navigate}
                    _materialExist={_materialExist}
                    _createErrorMessage={_createErrorMessage}
                    _deleteMaterial={_deleteMaterial}
              
                  />
                </div>
              </div>
            </div>
            <MessageLog
              errorMessages={[..._errorMessages, ..._errorDeleteMaterialData ]}
              successMessages={[..._successDeleteMaterialData]}
              warningMessages={[]}
              clearMessages={clearMessages}
            ></MessageLog>
             <div className="cardAlert">
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <ListModal
              setId={setMaterialParam}
              dataList={_materialsList}
              showListModal={showMaterialsList}
              setShowModal={setShowMaterialsList}
              title="List Of Materials"
              columns={[
                { field: "id", headerName: "Material ID", width: 100 },
                { field: "code", headerName: "Code", width: 250 },
                { field: "name", headerName: "Name", width: 350 },
                { field: "materialTypeId", headerName: "Material Type", width: 150}
                ]}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

